import { render, staticRenderFns } from "./simple-table.vue?vue&type=template&id=dfd0e9dc&"
import script from "./simple-table.vue?vue&type=script&lang=js&"
export * from "./simple-table.vue?vue&type=script&lang=js&"
import style0 from "./simple-table.vue?vue&type=style&index=0&id=dfd0e9dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports